import { render, staticRenderFns } from "./EditBus.vue?vue&type=template&id=dd321a26&scoped=true&"
import script from "./EditBus.vue?vue&type=script&lang=js&"
export * from "./EditBus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd321a26",
  null
  
)

export default component.exports